import { useBlogTagsStore } from "@/stores/blogTagsStore";
import { useBlogsStore } from "@/stores/blogsStore";
import { useRoute, useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/constants/routeNames";

export function useSelectBlogTag() {
  const tagsStore = useBlogTagsStore();
  const blogStore = useBlogsStore();
  const router = useRouter();
  const route = useRoute();

  function selectTag(tagId: number) {
    tagsStore.selectTag(tagId);
    blogStore.fetchBlogsCards(tagId);
    if (route.name !== ROUTE_NAMES.BLOG_LIST) {
      router.push({ name: ROUTE_NAMES.BLOG_LIST });
    }
  }

  return { selectTag };
}
